// LIVEMOA · 이용약관 페이지 (Production, TikTok Login Kit Review 대응).
// 시행일 2026-02-13. 운영사: 엠지컴퍼니. 실제 사업자정보 표시.
import React from 'react';
import { Link } from 'react-router-dom';
import LivemoaLegalHeader from '@/components/LivemoaLegalHeader';

const H2 = ({ children, id }) => (
  <h2 id={id} className="mt-10 mb-3 text-xl font-bold text-black dark:text-white">
    {children}
  </h2>
);
const P = ({ children }) => (
  <p className="my-2 text-sm leading-7 text-gray-700 dark:text-gray-300">{children}</p>
);
const UL = ({ children }) => (
  <ul className="my-2 ml-5 list-disc space-y-1 text-sm leading-7 text-gray-700 dark:text-gray-300">
    {children}
  </ul>
);

export default function Terms() {
  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A]" data-testid="terms-page">
      {/* TikTok Review T-R1 · 페이지 상단 LIVEMOA app icon 표시 (reviewer 반려사항 대응) */}
      <LivemoaLegalHeader current="terms" />
      <main>
        <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
          <header className="mb-8">
            <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-black dark:text-white">
              LIVEMOA 이용약관
            </h1>
            <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
              시행일: 2026년 2월 13일 · 운영자: 엠지컴퍼니 (LIVEMOA · 라이브모아)
            </p>
          </header>

          <H2 id="a1">제1조 (목적)</H2>
          <P>
            이 약관은 엠지컴퍼니(이하 "회사")가 제공하는 서비스 <b>LIVEMOA(라이브모아)</b>(이하
            "서비스")의 이용과 관련하여 회사와 이용자 간의 권리·의무, 책임사항 및 서비스
            이용조건을 규정함을 목적으로 합니다.
          </P>

          <H2 id="a2">제2조 (용어의 정의)</H2>
          <UL>
            <li><b>LIVEMOA</b>: 회사가 운영하는 라이브커머스 편성표·판매자 프로필·외부 라이브 방송 큐레이션 서비스.</li>
            <li><b>회원</b>: 이 약관에 동의하고 서비스에 가입한 자.</li>
            <li><b>일반회원</b>: 판매자로 승인되지 않은 회원.</li>
            <li><b>판매자</b>: 회사의 판매자 심사·승인 절차를 거쳐 서비스 내에서 상품·라이브 방송 정보를 등록할 수 있는 회원.</li>
            <li><b>라이브 방송</b>: 판매자가 서비스 내에 등록한 방송 정보 또는 외부 플랫폼에서 진행되는 방송.</li>
            <li><b>외부 플랫폼</b>: TikTok, YouTube, 그 밖에 서비스가 연동하는 제3자 서비스.</li>
            <li><b>상품</b>: 판매자가 서비스 내에 등록한 판매 대상.</li>
            <li><b>주문</b>: 이용자가 상품에 대해 서비스 내 또는 판매자 채널을 통해 구매 의사를 표시하는 행위.</li>
            <li><b>콘텐츠</b>: 서비스에 게시·전송된 텍스트·이미지·영상·라이브 데이터 일체.</li>
            <li><b>유료서비스</b>: 회사가 별도 유료로 제공하기로 정한 서비스(현재 미제공).</li>
          </UL>

          <H2 id="a3">제3조 (약관의 게시 및 변경)</H2>
          <P>
            회사는 이 약관의 내용을 서비스 화면에 게시합니다. 회사는 관련 법령을 위반하지 않는 범위에서
            이 약관을 개정할 수 있으며, 개정 시 시행일자 및 개정사유를 명시하여 최소 7일 전(이용자에게
            불리한 개정은 최소 30일 전) 서비스 화면에 공지합니다. 이용자가 시행일까지 명시적으로
            거부의사를 표시하지 않으면 개정 약관에 동의한 것으로 봅니다.
          </P>

          <H2 id="a4">제4조 (회원가입 및 계정)</H2>
          <UL>
            <li>회원가입은 서비스가 지원하는 인증 수단(카카오 로그인 등)을 통해 이루어집니다.</li>
            <li>회원은 하나의 계정만 사용해야 하며, 계정 정보를 제3자에게 양도·대여할 수 없습니다.</li>
            <li>판매자 자격은 회사의 심사·승인을 거쳐 부여되며, 판매자 자격의 유지·정지·회수는 회사 정책 및 관련 법령에 따릅니다.</li>
            <li>외부 플랫폼 계정 연결(예: TikTok Login Kit, YouTube OAuth)은 이용자의 명시적 동의를 전제로 이루어집니다.</li>
          </UL>

          <H2 id="a5">제5조 (서비스의 내용)</H2>
          <P>회사는 현재 다음과 같은 서비스를 제공합니다.</P>
          <UL>
            <li>라이브커머스 방송 편성표 및 알림</li>
            <li>판매자 프로필·팔로우·팔로우 알림</li>
            <li>외부 플랫폼(TikTok·YouTube 등) 라이브 방송 정보 큐레이션</li>
            <li>판매자 라이브 컨트롤(상품 노출·순서·소개 관리) 도구</li>
            <li>라이브 방송에 연동된 상품 정보 조회</li>
            <li>숏폼 콘텐츠(Short Clips) 노출</li>
            <li>주문 관련 편의 기능(장바구니·문의 등)</li>
          </UL>
          <P>
            결제·정산 등 아직 정식 개시되지 않은 기능은 사전 공지 후 별도로 제공될 수 있으며, 회사는
            서비스 내용을 관련 법령 및 정책에 따라 변경할 수 있습니다.
          </P>

          <H2 id="a6">제6조 (외부 플랫폼 연동)</H2>
          <UL>
            <li>회사는 TikTok·YouTube 등 외부 플랫폼과 API/OAuth 를 통해 연동될 수 있습니다.</li>
            <li>외부 플랫폼의 정책·서비스 장애·API 변경·계정 상태 등에 대해서는 해당 플랫폼의 정책이 적용됩니다.</li>
            <li>외부 플랫폼 계정 연결의 해제는 서비스 내 설정 화면 또는 해당 플랫폼의 계정 관리 화면에서 수행할 수 있습니다.</li>
          </UL>

          <H2 id="a7">제7조 (판매자의 의무)</H2>
          <P>판매자는 자신이 등록·제공하는 다음 정보에 대한 책임을 부담합니다.</P>
          <UL>
            <li>상품정보의 정확성 및 관련 법령 준수</li>
            <li>가격·재고·배송·교환·반품·환불 안내</li>
            <li>방송 내용의 관련 법령 및 외부 플랫폼 정책 준수</li>
            <li>「전자상거래 등에서의 소비자보호에 관한 법률」등 관계 법령 준수</li>
          </UL>

          <H2 id="a8">제8조 (이용자의 의무)</H2>
          <UL>
            <li>타인 계정·정보의 도용</li>
            <li>서비스 정상 운영을 방해하는 행위</li>
            <li>회사·판매자·제3자의 지식재산권 침해</li>
            <li>불법·불건전 콘텐츠 게시 및 관련 법령 위반 행위</li>
            <li>자동화된 수단을 이용한 부정 접근·조회·수집</li>
          </UL>

          <H2 id="a9">제9조 (주문 및 결제)</H2>
          <P>
            현재 서비스는 라이브 방송·판매자 채널과 연동되는 주문 편의 기능을 제공합니다. 실제 결제
            수단·정산 서비스가 정식 개시되기 전까지, 결제·환불·정산은 판매자 개별 채널을 통해
            처리될 수 있으며, 이 경우 해당 판매자 및 해당 채널의 정책이 적용됩니다.
          </P>

          <H2 id="a10">제10조 (서비스의 변경 및 중단)</H2>
          <P>
            회사는 시스템 점검, 장애, 외부 API 장애, 외부 플랫폼 정책 변경, 그 밖의 불가피한 운영상
            사유가 있는 경우 서비스의 전부 또는 일부를 변경·중단할 수 있습니다.
          </P>

          <H2 id="a11">제11조 (지식재산권)</H2>
          <UL>
            <li>회사가 서비스에 게시한 콘텐츠(디자인·UI·문구 포함)의 저작권 및 지식재산권은 회사에 귀속됩니다.</li>
            <li>판매자·이용자가 서비스에 게시한 콘텐츠의 권리는 각 게시자에게 귀속되며, 게시자는 회사가 서비스 운영·홍보 목적으로 필요한 범위에서 해당 콘텐츠를 이용할 수 있도록 사용을 허락합니다.</li>
            <li>외부 플랫폼에서 유래하는 콘텐츠의 권리는 해당 플랫폼 및 원 게시자의 정책에 따릅니다.</li>
          </UL>

          <H2 id="a12">제12조 (책임 제한)</H2>
          <P>
            회사는 관련 법령을 위반하지 않는 합리적인 범위에서, 천재지변·외부 플랫폼 장애·이용자의
            귀책사유·판매자와 이용자 간의 개별 거래로 인해 발생한 손해에 대하여는 책임을 지지 않을
            수 있습니다. 다만, 관련 법령에서 소비자에게 인정하는 권리를 부당하게 제한하지 않습니다.
          </P>

          <H2 id="a13">제13조 (준거법 및 분쟁 해결)</H2>
          <P>
            이 약관은 대한민국 법률을 준거법으로 합니다. 서비스 이용과 관련하여 발생한 분쟁은
            민사소송법상 관할 법원에 제기할 수 있습니다.
          </P>

          <BusinessInfo />

          <p className="mt-10 text-xs text-gray-500 dark:text-gray-400">
            관련 문서: <Link to="/privacy" className="underline hover:text-[#FF3B30]" data-testid="terms-to-privacy">개인정보처리방침</Link>
          </p>
        </article>
      </main>
    </div>
  );
}

export function BusinessInfo() {
  return (
    <section
      className="mt-12 rounded-2xl border border-black/10 dark:border-white/10 bg-gray-50 dark:bg-[#111] p-5 text-xs leading-6 text-gray-700 dark:text-gray-300"
      data-testid="business-info"
    >
      <div className="font-bold text-sm text-black dark:text-white mb-2">사업자정보</div>
      <div>상호: <b>엠지컴퍼니</b> · 서비스명: LIVEMOA (라이브모아)</div>
      <div>대표자: 김현민</div>
      <div>사업자등록번호: 685-18-02463</div>
      <div>통신판매업 신고번호: 제2025-인천서구-3628호</div>
      <div>주소: 인천광역시 서구 중봉대로612번길 16, 13층 1306호 (청라동, 서후센타시아)</div>
      <div>고객문의: <a href="mailto:k615745@naver.com" className="underline">k615745@naver.com</a> · 010-6744-6344</div>
      <div className="mt-1 text-[11px] text-gray-500">※ 현재 연락처는 LIVEMOA 전용 이메일·대표전화 개설 후 교체 예정입니다.</div>
    </section>
  );
}
